import { Extension } from "@tiptap/core";
import { Plugin, PluginKey } from "@tiptap/pm/state";

// The spellCheck prop on EditorContent lands on TipTap's wrapper div, not on the
// inner contenteditable (ProseMirror's view.dom). props.attributes is the idiomatic
// way to set the attribute directly on the editable element.
export const SpellCheck = Extension.create({
  name: "spellCheck",

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("spellCheck"),
        props: {
          attributes: { spellcheck: "true" },
        },
      }),
    ];
  },
});
